<template>
  <ion-page id="mainmenu-page">
    <ion-content>

  <div v-if="showState == SHOW_EXPLAINTOUR">
    <ExplainTour :screen="explainTourScreen"
                  :wordsSpoken="explainTourWordsSpoken"
                  :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                @toolbar-click="explainTourToolbarClick" />

  </div>


  <div v-show="showState == SHOW_MAINMENU">

     <TopLine :style="styleTopline" :showDone="showDone" title="Verbal Chess" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

      <ion-list id="mainmenu" :style="styleMiddle">
        <div v-if="props.welcomeMessage != ''" class="myheading">
          <span v-if="props.welcomeMessage == 'login'">
            {{ translateEnglishWords("Welcome Back !") }}
          </span>
          <span v-if="props.welcomeMessage == 'register'">
            {{ translateEnglishWords("Welcome !") }}
          </span>
        </div>

        <ion-item v-show="!audioCanBeHeard" class="enable-audio-item" aria-live="polite">
          <ion-button expand="block" size="medium" :disabled="disableAudioCanBeHeard" @click="sayWelcomeMp3(false)">
            <span class="ion-text-wrap">{{ enableSpeechButton }}</span>
          </ion-button>
        </ion-item>
        <ion-item>
          <ion-label @click="onClick('/accountmenu')">
            {{ youLoginRegisterText }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label @click="onClick('/lichessmenu')">
            {{ playLichessString }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label @click="onClick('/enginemenu')">
            {{ playEnginesString }}
          </ion-label>
        </ion-item>
        <ion-item>
        <ion-label @click="onClick('/subscribe')">
          <span v-if="isSubscriberDisabledFlag">{{ subscribeText }}!</span>
          <span v-if="!isSubscriberDisabledFlag">{{ subscriberText }}: {{ subscriptionExpireText }}</span>
          
        </ion-label>
        </ion-item>
        <ion-item>
        <ion-label @click="onClick('/landingpage')">
          {{ showLandingPageString }}
        </ion-label>
        </ion-item>

        <ion-item v-show="showIOSTile">
          <ion-label @click="onClick('install')">
            {{ translatePhrase("Install App") }}
          </ion-label>
        </ion-item>

        <ion-item v-show="isInstallable && !showIOSTile">
          <ion-label @click="onClick('install')">
            {{ translatePhrase("Install App") }}
          </ion-label>
        </ion-item>

        <ion-item v-if="isUrlFromAndroid">
          <ion-label @click="onClick('android')">
            {{ translatePhrase("Return To Android Version") }}
          </ion-label>
        </ion-item>
        <ion-item v-if="isUrlFromIOS">
          <ion-label @click="onClick('IOS')">
            {{ translatePhrase("Return To IOS Version") }}
          </ion-label>
        </ion-item>
        <ion-item >
          <ion-label color="danger">
            <h3>
              <span>{{ part1ofInfoLine }}</span>
              <span class="italics"> '{{ part2ofInfoLine }}' </span>
              <span>{{ part3ofInfoLine }}</span>
            </h3>
          </ion-label>
        </ion-item>
  
       </ion-list>
    <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </div>

      </ion-content>
  </ion-page>
  

</template>

<script setup>

import { IonButton, IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';

import { computed } from "@vue/reactivity"
import { storeToRefs } from 'pinia';

import { ref, watch , onMounted } from 'vue'
import ToolBar from '@/components/ToolBar.vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { usePwaStore } from '@/stores/pwaStore';

import { translateEnglishWords, translatePhrase } from '@/composables/translation';
import { doStartupCheck } from '@/composables/startupCheck.js'
import TopLine from '@/components/TopLine.vue'
import { voiceAddMicrophoneSupport } from '@/composables/voicesSupport.js'
import { getURLContents } from '@/composables/getData.js'
import { useGetData } from '@/composables/getData.js'

import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

import ExplainTour from '@/components/ExplainTour.vue'

const emit = defineEmits(['where-next','word-list','mic-is-muted','attempt-audio-resume'])

const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      },
      welcomeMessage : {
        type : String,
        default : ""
      },
    })


const pwaStore = usePwaStore();
const { isInstallable } = storeToRefs(pwaStore);

// ── Computed ───────────────────────────────────────────────────────────────
const isIos = computed(() =>
  /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
)

const isInstalled = computed(() =>
  window.matchMedia('(display-mode: standalone)').matches
)

const showIOSTile = computed(() =>
  (isIos.value && !isInstalled.value)
)

const wordsSaid = computed({get() {return props.wordsSaid}})
const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

const connectionStore = useConnectionStore()
const windowSizeStore = useWindowSizeStore()

var url_a = localStorage.getItem("url_a")
const isUrlFromAndroid = ref(url_a != null && url_a == "android" && typeof(Android) != "undefined")
const isUrlFromIOS = ref(url_a != null && url_a == "ios")

const welcomeMp3URL = connectionStore.getWelcomeMp3URL
const audioCanBeHeard = ref(connectionStore.audioCanBeHeard)
const enableSpeechButton = ref(translatePhrase("For this device, you must click this button to allow program to speak"))

const wordlistMainMenu = "command scroll up down sign log in register my account subscribe subscriber explain play lee chess on line engine engines ignore mute listen show landing return done install"
const wordlistTrigger = ref(0)

const disableAudioCanBeHeard = ref(false)

const playLichessString = ref(translateEnglishWords("Play on line - Lichess"))
const playEnginesString = ref(translateEnglishWords("Play Engines & Friends"))
const showLandingPageString = ref(translateEnglishWords("Show Landing Page"))

const part1ofInfoLine = ref(translatePhrase("Say"))
const part2ofInfoLine = ref(translateEnglishWords("Command Explain"))
const part3ofInfoLine = ref(translatePhrase("for help on any screen"))
const registerSigninString = ref(translateEnglishWords("Register / Signin , Preferences & Support"))
const myAccountString = ref(translateEnglishWords("My Account -- Preferences & Support"))
const explainString = ref(translateEnglishWords("Explain & Show New Info"))

// show "done" if IOS
const showDone = ref(isUrlFromIOS.value)

const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
emit("mic-is-muted",microphoneIsMuted.value)

const wordlist = ref(wordlistMainMenu)
emit("word-list",wordlistMainMenu)

var seenTour = connectionStore.getSeenTour

// For testing
//connectionStore.setPreviouslySeenProgramVersion("0.0.0")
//seenTour = ""

const verbalVersion = connectionStore.getVersion
const isDark = ref(connectionStore.getDarkmode != "light")

const urlParams =  new URLSearchParams(window.location.search)

const SHOW_MAINMENU = 0
const SHOW_EXPLAINTOUR = 1
const SHOW_DOWNLOADING = 2
const showState = ref(SHOW_MAINMENU)

const TOOLBAR_EXPLAIN = 0

const toolbarElements = ref([
  { index : TOOLBAR_EXPLAIN, label : explainString.value + " V(" + verbalVersion + ")" ,disabled : false},
  ])

const toolbarTrigger = ref(0)

const explainTourWordsSpoken = ref("")
const explainTourScreen = ref("")
const explainTourWordsSpokenTrigger = ref(0)

var isSubscriber = connectionStore.getIsSubscriber

const dummyRef = ref(connectionStore.getDummy)

const youLoginRegisterText = ref((dummyRef.value == 0) ? myAccountString.value : registerSigninString.value)
const isSubscriberDisabledFlag = ref(isSubscriber != 1)
const subscribeText = ref(translateEnglishWords("Subscribe"))
const subscriberText = ref(translateEnglishWords("Subscriber"))
const subscriptionExpireText = ref(connectionStore.getSubscriberExpireDisplayString)
// const subscriberText = ref((isSubscriberDisabledFlag.value) ? "Subscribe!" : "Subscriber: " +
//             connectionStore.getSubscriberExpireDisplayString)

const welcomeMessageSaid = false

// home page

var verbalHomePage = "app"

// speaking

var voices = []
var engineVoiceNumber = -1
var playerVoiceNumber = -1

 watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

 watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  // https://stackoverflow.com/questions/12489546/getting-a-browsers-name-client-side

  var hasPlayed = false;
  function handleFirstPlay(event) {
    if (!hasPlayed) {
      console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ FIRST PLAY @@@@@@@@@@@@@@@@@@")
      hasPlayed = true;

      // Remove listener so this only gets called once.
      const aud = event.target;
      aud.removeEventListener("play", handleFirstPlay);

      connectionStore.setAudioCanBeHeard(true)
      audioCanBeHeard.value = true
      // Start whatever you need to do after first playback has started
    }
  }

  // https://developer.mozilla.org/en-US/docs/Web/Media/Guides/Autoplay

  function sayWelcomeMp3(firstTry) {
    if (!firstTry)
      disableAudioCanBeHeard.value = true

    // gemini suggestions adding this before the first speaking
    // if (navigator.audioSession) {
    //   navigator.audioSession.type = 'playback'; 
    // }

    // claude suggests this before VOSK but maybe it should be before first speaking?
    if ('audioSession' in navigator) {
      try {
        navigator.audioSession.type = 'play-and-record'
      } catch (e) {
        console.log('audioSession type not supported:', e)
      }
    }

    var audioPlayer = document.getElementById("myAudio")
    audioPlayer.src = welcomeMp3URL

    // Fire-and-forget — uses this gesture to also unlock VOSK's AudioContext
    emit('attempt-audio-resume')

    const startPlayPromise = audioPlayer.play()

    if (startPlayPromise !== undefined) {
      startPlayPromise
        .then(() => {
          connectionStore.setAudioCanBeHeard(true)
          audioCanBeHeard.value = true
          disableAudioCanBeHeard.value = false
        })
        .catch((error) => {
          console.log("***** SHOW BUTTON --- ", error)
          connectionStore.setAudioCanBeHeard(false)
          audioCanBeHeard.value = false
          disableAudioCanBeHeard.value = false
        })
    } else {
      console.log("********** start play promise is undefined")
    }
  }

  onMounted(() => {

    // give it a 500ms for the installable flag to get set
    
      setTimeout(function () {
      console.log("**** isINstallable",isInstallable.value)
      if (isInstallable.value) {
        // buttonArray.value.push({ index: 4,title : "Install App", program: "pwa", second : "", disabled:false})
        // buttonTrigger.value++
      }
    }, 500);

    if (audioCanBeHeard.value == false) {
      sayWelcomeMp3(true)
    }

  })

function getBrowserName() {
  const agent = window.navigator.userAgent.toLowerCase();
  const browser =
      agent.indexOf('edge') > -1 ? 'edge'
      : agent.indexOf('edg') > -1 ? 'chromium based edge'
      : agent.indexOf('opr') > -1 && window.opr ? 'opera'
      : agent.indexOf('chrome') > -1 && window.chrome ? 'chrome'
      : agent.indexOf('trident') > -1 ? 'ie'
      : agent.indexOf('firefox') > -1 ? 'firefox'
      : agent.indexOf('safari') > -1 ? 'safari'
      : 'other';

  //console.log(`*********************   ${agent}\n${browser}`);
  return (browser)
}

function afterStartupCallbackRoutine(stuffChanged) {

  // // look at passed URL parameter to see what the default home page is
  // if (urlParams.has('app')) {
  //   verbalHomePage = "app"
  //   connectionStore.setVerbalHomePage("app")
  // }
  // else
  // if (urlParams.has('program')) {
  //   verbalHomePage = "program"
  //   connectionStore.setVerbalHomePage("program")
  // }
  // else
  //   verbalHomePage = connectionStore.getVerbalHomePage
  // if (verbalHomePage == "program") {
  //   toolbarElements[TOOLBAR_SHOW_LANDING_PAGE].label = "Set Landing Page as web home"
  //   toolbarTrigger.value++
  // }
  
  isSubscriber = connectionStore.getIsSubscriber
  dummyRef.value = connectionStore.getDummy
  
  youLoginRegisterText.value = (dummyRef.value == 0) ? "My Account, Preferences & Support" : "Register / Signin, Preferences & Support"
  isSubscriberDisabledFlag.value = isSubscriber != 1
  subscriberText.value = (isSubscriberDisabledFlag.value) ? "Subscribe!" : "Subscriber: " +
                connectionStore.getSubscriberExpireDisplayString

  checkForForceTour()
}

function checkForForceTour() {
    showState.value = SHOW_MAINMENU

    if (seenTour != "y") {
      connectionStore.setSeenTour("y")
      connectionStore.setPreviouslySeenProgramVersion(verbalVersion)
      seenTour = "y"
      explainTourInitialize(false)
    }
    else {
      // has the version number changed?
      let previousVersion = connectionStore.getPreviouslySeenProgramVersion
      let previousParts = previousVersion.split(".")
      let currentParts = verbalVersion.split(".")
      if (previousParts[0] != currentParts[0] || previousParts[1] != currentParts[1]) {
            connectionStore.setPreviouslySeenProgramVersion(verbalVersion)
            explainTourInitialize(true)
      }
    }
}

function onClick(path,puzzleOption) {

  if (path == "install") {
    console.log("install")
    if (showIOSTile.value) {
      console.log("IOS Install note")
      explainIOS()
    }
    else {
      console.log("Install APP")
      pwaStore.installApp()
    }
    return
  }

  if (path == "IOS") {
    window.webkit.messageHandlers.myHandler.postMessage('DONE');
    return
  }

  if (path == "android") {
    console.log("is android",Android)
    Android.AndroidMessage("DONE","")
    return
  }

  //console.log("################### PATH ",path,puzzleOption)
  if (path == "/puzzles" || path == "/movefollowing") {
    //console.log("path is puzzles or movefollowing")
    connectionStore.setPlayType(puzzleOption)
  }
  emit("where-next",path)
}

// function openInNewTab(href) {
//   Object.assign(document.createElement('a'), {
//     target: '_blank',
//     rel: 'noopener noreferrer',
//     href: href,
//   }).click();
// }


// function showLandingPage() {
//   openInNewTab("https://www.verbalchess.fun/?app")
//   //window.location.href = "https://www.verbalchess.fun/?app"
// }

// START Explain Tour Routines

function explainTourInitialize(startWithNew) {
  explainTourScreen.value = (startWithNew) ? "mainnew" : "main";
  wordlist.value = connectionStore.getExplainTourWords
  emit("word-list",wordlist.value)

  wordlistTrigger.value++
  showState.value = SHOW_EXPLAINTOUR
}

function explainIOS() {
  explainTourScreen.value = "install_ios";
  wordlist.value = connectionStore.getExplainTourWords
  emit("word-list",wordlist.value)

  wordlistTrigger.value++
  showState.value = SHOW_EXPLAINTOUR
}

function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {

      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_MAINMENU
        wordlist.value = wordlistMainMenu
        emit("word-list",wordlist.value)

        wordlistTrigger.value++
        break
  }
}

// END Explain Tour Routines

function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

function toolbarClick(arrayIndex) {
  switch (arrayIndex) {
    case TOOLBAR_EXPLAIN :
      processWords("command explain")
      break
  }
}

function mainMenuProcessWord(returnArray) {
  var url = ""

  switch (returnArray[0]) {
    case "install" :
      if (isInstallable.value)
        onClick("install")
      break
    case "scroll" :
      scrollElement("mainmenu",returnArray[1])
      break
    case "mute" :
      microphoneIsMuted.value = true 
      emit("mic-is-muted",microphoneIsMuted.value)
      connectionStore.setMicrophoneIsMuted(true)
      break
    case "listen" :
      microphoneIsMuted.value = false 
      emit("mic-is-muted",microphoneIsMuted.value)
      connectionStore.setMicrophoneIsMuted(false)
      break
    case "explain" :
      explainTourInitialize(false)
      break;
    case "return" :
      if (isUrlFromIOS.value)
        onClick("IOS")
      else
      if (isUrlFromAndroid.value)
        onClick("android")
      break;
    case "engine" :
    case "engines" :
      //console.log("ENGINE MENU")
      emit("where-next","/enginemenu")
      break
    case "lichess" :
      //console.log("LICHESS MENU")
      emit("where-next","/lichessmenu")
      break
    case "done" :
      if (isUrlFromIOS.value)
        onClick("IOS")
      break
    case "support" :
      //console.log("SUPPORT MENU")
      emit("where-next","/accountmenu")
      break
    case "landing" :
      emit("where-next","/landingpage")
      break
    case "subscribe" :
      //console.log("SUBSCRIBE MENU")
      emit("where-next","/subscribe")
      break
    case "account" :
      //console.log("Account menu")
      emit("where-next","/accountmenu")
      break
    case "set_program" :
      url = "https://www.verbalchess.fun/set_program.html"
      location.href = url
      break
    case "set_app" :
      url = "https://www.verbalchess.fun/set_app.html"
      location.href = url
      break
  }
}

function processWords(text) {
  //console.log("text in Main Menu ",showState.value,text)

  switch (showState.value) {
    case SHOW_DOWNLOADING :
      timerCanStop = true
      if (text == "model-loaded") {
        doStartupCheck(false,afterStartupCallbackRoutine)
      }
      break
    case SHOW_MAINMENU :
      const returnArray = parseWordsSaid(text)
      mainMenuProcessWord(returnArray)
      break
    case SHOW_EXPLAINTOUR :
      explainTourWordsSpoken.value = text
      explainTourWordsSpokenTrigger.value++
      break;
  }
}

function parseCommands(words,currentWordIndex) {
  
  //console.log("in parse commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore") {
          return ["ignore",""];
      }
      if (currentWord == "explain") {
          return ["explain",""]
      }
      if (currentWord == "listen") {
        return ["listen",""]
      }
      if (currentWord == "mute") {
        return ["mute",""]
      }
      if (currentWord == "show" || currentWord == "landing") {
          return ["landing",""]
      }
      if (currentWord == "install") {
          return ["install",""]
      }
      if (currentWord == "done") {
          return ["done",""]
      }
      if (currentWord == "scroll") {
          if (nextWord == "up") {
              return ["scroll", "up"]
          }
          if (nextWord == "down") {
              return ["scroll", "down"]
          }
      }
      
      if (currentWord == "my" || currentWord == "account" || currentWord == "register" ||
                      ((currentWord == "log" || currentWord == "sign") && (nextWord == "in" || nextWord == "off")))  {
          return ["account", ""]
      }
      if (currentWord == "lee" && nextWord == "chess") {
          return ["lichess",""]
      }
      if (currentWord == "on" && nextWord == "line") {
          return ["lichess",""]
      }
      if (currentWord == "engine" || currentWord == "engines") {
          return ["engines",""]
      }
      if (currentWord == "puzzle" || currentWord == "puzzles") {
          return ["puzzles",""]
      }
      if (currentWord == "support") {
          return ["support",""]
      }
      if (currentWord == "subscribe" || currentWord == "subscriber") {
          return ["subscribe",""]
      }
      if (currentWord == "return") {
          return ["return",""]
      }
      if (currentWord == "explain") {
          return ["explain",""]
      }
      if (currentWord == "set" && nextWord == "landing")
        return ["set_app", ""]
      if (currentWord == "set" && nextWord == "program")
        return ["set_program", ""]

      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

function parseWordsSaid(str) {
 
  const words = str.split(" ")

  //console.log("string ",str)
  //console.log("words",words,words.length)
  if (words.length == 0) {
      return ["ignore",""];
  }

  var currentWord = (words.length > 0) ? words[0] : "xyz"
  var nextWord = (words.length > 1) ? words[1] : "xyz"
  var nextNextWord = (words.length > 2) ? words[2] : "xyz"
        
  //console.log("current word",currentWord)

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore") {
          return ["ignore",""];
      }

      if (currentWord == "command") {
        let returnArray = parseCommands(words, i+1)
          return returnArray
      }
      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""]
}

function startTimer() {
    
    function oneSecondInterval() {
      if (timerCanStop ) {
        clearInterval(id)
        return
      }
      timerAmount.value++
    }
    var id = setInterval(oneSecondInterval, 1000)
  }

</script>

<style scoped>

.enable-audio-item {
 --padding-start: 0;
  --padding-end: 0;
  border: 4px solid var(--ion-color-warning);
  border-radius: 8px;
}

ion-label {
    cursor: pointer;
 }

.italics {
  font-style: italic;
}

.myheading {
  background: #4c6ca0;
  color : white;
  font-size : 20px;
  font-style: italic;
  padding-left: 30px;
}

</style>